<nb-card class="prereq-dialog">
  <nb-card-header>
    <h4><nb-icon icon="link-2-outline"></nb-icon>Verknüpfte Kursinhalte</h4>
    <p class="prereq-dialog__subtitle">{{ courseName }}</p>
  </nb-card-header>
  <nb-card-body>
    <app-course-prerequisites
      [courseId]="courseId"
      [courseName]="courseName"
      [courses]="courses"
      [canRequest]="canRequest"
    ></app-course-prerequisites>
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="primary" (click)="dialogRef.close()">
      {{ 'buttons.close' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
